"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.searchPreviewShade = void 0;
var _fetching = require("@ori/fetching");
var _labels = require("./labels");
const searchPreviewShade = exports.searchPreviewShade = (0, _fetching.gql)`
  ${_labels.labels}
  fragment SearchPreviewShade on Product {
    shadeName
    hexColors
    colorImageUrl
    productCode
    formattedPrice {
      price {
        basicCataloguePrice
        currentPrice
        priceAfterImmediateDiscount
      }
    }
    labels {
      ...ProductLabels
    }
  }
`;